/**
 * File: form-toolkit.js
 *
 * Import and initialize functions for zoom accessibility issue
 */

export default {
  viewport:  document.querySelector("meta[name=viewport]"),
  init() {
    if (this.viewport) {
      this.render();
    }
  },
  render() {
    this.viewport.setAttribute('content', 'width=device-width, initial-scale=1');
  },
};
